<template>
  <v-snackbar v-model="show" :color="color">
    {{message}}
    <v-btn text dark @click="show = false">
      Sluiten
    </v-btn>
  </v-snackbar>
</template>

<script>
/**
 * Based upon
 * Defining watchers and base concept:
 *    https://medium.com/@fishpercolator/implementing-a-global-snackbar-in-nuxt-js-vuetify-using-vuex-a92b78e5651b
 * Vuex-orm: you cannot register 'normal' vuex-modules, but you have to piggyback them on 'entities'
 *    https://vuex-orm.org/guide/digging-deeper/vuex-module.html#defining-modules
 * De-register an initiated watcher (and could overview-article)
 *    https://dev.to/viniciuskneves/watch-for-vuex-state-changes-2mgj
 */
export default {
  name: 'Snackbar',

  data () {
    return {
      show: false,
      message: '',
      color: 'success'
    };
  },

  // https://medium.com/@fishpercolator/implementing-a-global-snackbar-in-nuxt-js-vuetify-using-vuex-a92b78e5651b
  created: function () {
    this.unwatch = this.$store.watch(state => state.entities.participants.message, () => {
      const msg = this.$store.state.entities.participants.message;
      if (msg !== '') {
        this.color = this.$store.state.entities.participants.color;
        this.message = msg;
        this.show = true;
        this.$store.commit('entities/participants/SET_SUCCESS', ''); // reset the message
      }
    });
  },
  beforeDestroy () {
    this.unwatch();
  }

};
</script>

<style scoped>

</style>
